module.exports = __webpack_public_path__ + "img/caret-left.6ebabf72.svg";